import { useQuery, useQueryClient } from '@tanstack/react-query'
import { getWebsiteThemeById } from 'src/editor/api/website-themes-api'
import { WebsiteThemeInterface } from 'src/shared/types/website-settings-types'

export const useWebsiteTheme = () => {
  const queryClient = useQueryClient()
  return useQuery<WebsiteThemeInterface, Error>({
    queryKey: ['websiteTheme'],
    queryFn: () => {
      const id = queryClient.getQueryData<number>(['activeThemeId'])

      if (id === null || id === undefined) {
        throw new Error('No activeThemeId provided')
      }

      return getWebsiteThemeById(id)
    },
    staleTime: 1000 * 60 * 5,
    enabled: false,
  })
}
